import { createSelector } from 'reselect';
import identity from 'lodash/identity';
import property from 'lodash/property';

export default createSelector(
  identity,
  property('queryBuilder'),
);
